import { render } from "./view_logs.html?vue&type=template&id=167cb8f3&scoped=true&external"
import script from "./view_logs.js?vue&type=script&lang=js&external"
export * from "./view_logs.js?vue&type=script&lang=js&external"

import "./ViewLogs.vue?vue&type=style&index=0&id=167cb8f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167cb8f3"]])

export default __exports__